import { render, staticRenderFns } from "./CommonStoreFooter.vue?vue&type=template&id=2b9296d3&scoped=true"
import script from "./CommonStoreFooter.vue?vue&type=script&lang=js"
export * from "./CommonStoreFooter.vue?vue&type=script&lang=js"
import style0 from "./CommonStoreFooter.vue?vue&type=style&index=0&id=2b9296d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9296d3",
  null
  
)

export default component.exports